export const DEFAULT_REGION_NAME = 'us-east-1';
export const DEFAULT_SERVICE_NAME = 'rbi';
export const DEFAULT_STAGE_NAME = 'localdev';
